import { render, staticRenderFns } from "./BitriseMD.vue?vue&type=template&id=1119d6be&scoped=true"
import script from "./BitriseMD.vue?vue&type=script&lang=js"
export * from "./BitriseMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1119d6be",
  null
  
)

export default component.exports